import React, { ReactNode } from "react";

import Button, { ButtonProps } from "../buttons/Button";

interface Props {
  color?: ButtonProps["color"];
  isLoading?: boolean;
  isSubmitting?: boolean;
  isCancelling?: boolean;
  isCancelDisabled?: boolean;
  isSubmitDisabled?: boolean;
  submitLabel?: string;
  submitTooltip?: string;
  submitIcon?: ReactNode;
  cancelLabel?: string;
  cancelTooltip?: string;
  onSubmit: (event: React.MouseEvent) => void;
  onCancel?: (event: React.MouseEvent) => void;
}

const SubmitButtons: React.FC<React.PropsWithChildren<Props>> = (props) => {
  return (
    <>
      <Button
        isLoading={props.isCancelling}
        disabled={props.isLoading || props.isCancelDisabled}
        title={props.cancelTooltip ?? props.cancelLabel ?? "Cancel"}
        onClick={props.onCancel}
      >
        {props.cancelLabel || "Cancel"}
      </Button>
      <Button
        autoFocus
        isLoading={props.isLoading || props.isSubmitting}
        disabled={
          props.isSubmitting || props.isLoading || props.isSubmitDisabled
        }
        color={props.color || "primary"}
        title={props.submitTooltip ?? props.submitLabel ?? "Submit"}
        icon={props.submitIcon}
        onClick={props.onSubmit}
      >
        {props.submitLabel || "Submit"}
      </Button>
    </>
  );
};

export default SubmitButtons;
